module.exports = __webpack_public_path__ + "img/13.c1e20989.jpg";